import _ from 'lodash';
import { useMemo } from 'react';

import {
  Divider,
  Paper,
  Popper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import { CalculationInput } from 'generated/graphql';
import { popperUtil } from 'modules/common';



export type CalculationInputPopperProps = popperUtil.IBasePopperProps & {
  inputs: CalculationInput[];
  formula: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: CalculationInputPopperProps) => {
  const sorted = useMemo(() => {
    return _.sortBy(props.inputs, (i) => i.year + i.period);
  }, [props.inputs]);

  return (
    <Popper
      open={props.open}
      anchorEl={props.anchorEl}
      onMouseLeave={() => props.handleClose()}
      sx={{
        zIndex: 1_000_000
      }}
    >
      <Paper sx={{
        p: 1
      }}
      >
        <TableContainer>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell>Metric</TableCell>
                <TableCell>Year</TableCell>
                <TableCell>Period</TableCell>
                <TableCell>Value</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {sorted.map((input, i) => (
                <TableRow key={i}>
                  <TableCell>
                    {input.metric.displayName}
                  </TableCell>

                  <TableCell>
                    {input.year}
                  </TableCell>

                  <TableCell>
                    {input.period.toUpperCase()}
                  </TableCell>

                  <TableCell align='right'>
                    {input.formattedValue}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Divider />

        <Typography variant='chartTitle'>{props.formula}</Typography>
        {/* <BlockMath math={props.formula} /> */}
      </Paper>
    </Popper>
  );
};
